export type TableThemeId = 'classic' | 'neon' | 'space';

export interface TableTheme {
  id: TableThemeId;
  name: string;
  name_ru: string;
  bgClass: string;
  cardClass: string;
  accentClass: string;
  headerClass: string;
}

export const TABLE_THEMES: TableTheme[] = [
  {
    id: 'classic',
    name: 'Classic Green',
    name_ru: 'Классический',
    bgClass: 'bg-emerald-950/20',
    cardClass: 'bg-emerald-900/10 border-emerald-500/20',
    accentClass: 'text-emerald-400',
    headerClass: 'bg-emerald-900/40',
  },
  {
    id: 'neon',
    name: 'Cyber Neon',
    name_ru: 'Киберпанк',
    bgClass: 'bg-slate-950',
    cardClass: 'bg-slate-900 border-cyan-500/30 shadow-[0_0_15px_rgba(6,182,212,0.1)]',
    accentClass: 'text-cyan-400',
    headerClass: 'bg-slate-900/80 border-b border-cyan-500/20',
  },
  {
    id: 'space',
    name: 'Deep Space',
    name_ru: 'Космос',
    bgClass: 'bg-gray-950 bg-gradient-to-b from-gray-950 via-indigo-950/20 to-gray-950',
    cardClass: 'bg-gray-900/60 border-purple-500/30 backdrop-blur-xl',
    accentClass: 'text-purple-400',
    headerClass: 'bg-gray-950/80 border-b border-purple-500/20',
  }
];

export function getTheme(id: string): TableTheme {
  return TABLE_THEMES.find(t => t.id === id) || TABLE_THEMES[0];
}
